<template>
  <div v-if="equipmentModelValue.length > 0"
       class="sub-title">{{ $t('space.equipments') }}
  </div>
  <div v-if="equipmentModelValue.length > 0"
       class="flex flex-wrap">
    <div class="flex items-start w-1/2 mb-[12px]"
         v-for="equipment in equipmentModelValue">
      <img class="w-[20px] mr-[4px] mt-[2px]"
           :src="equipment.supply_icon?picUrl + equipment.supply_icon:picUrl+customEquipmentsIconName"
           alt="">
      <div class="flex flex-col">
                <span class="text-[16px] text-osn-dark-grey-00">
                  {{ equipment.name + (equipment.amounts > 0 ? `*${equipment.amounts}` : '') }}
                </span>
        <span class="text-[14px] text-osn-grey-01">
                  {{ equipment.description }}
                </span>
      </div>
    </div>
  </div>
</template>
<script setup
        lang="ts">
interface Equipment {
  supply_icon: string;
  name: string;
  amounts: number;
  description: string;
}


import {ref} from "vue";

const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const customEquipmentsIconName = ref(import.meta.env.VITE_APP_BASE_CUSTOM_EQUIPMENTS_ICON)
const equipmentModelValue = defineModel<Equipment[]>('spaceEquipment', { type: Array, default: () => [] });


</script>
<style scoped
       lang="scss">

</style>
